import '@iotize/tap/service/impl/group';
import '@iotize/tap/service/impl/interface';

import { Tap } from '@iotize/tap';

import { debug } from './debug';
import { AuthMethod, UsernamePassword } from './definitions';
import { ScramAuth } from './scram-auth';
import { hashLoginPassword } from './utility';

const TAG = 'BasicAuth';

export class BasicAuth
  implements AuthMethod<UsernamePassword, ScramAuth.SessionData>
{
  private get hashPassword(): boolean {
    return this.options?.hashPassword || false;
  }

  constructor(
    private tap: Tap,
    public options: {
      hashPassword?: boolean;
    } = {
      hashPassword: false,
    },
  ) {}

  /**
   * Tap login
   *
   */
  public async login(params: UsernamePassword): Promise<ScramAuth.SessionData> {
    const { username, password } = params;
    let response;
    if (this.hashPassword) {
      debug(TAG, `Using hash password login`);
      response = await this.tap.service.interface.loginWithHash({
        username,
        password: hashLoginPassword(password),
      });
    } else {
      debug(TAG, `Using regular login`);
      response = await this.tap.service.interface.login({
        username,
        password,
      });
    }
    response.successful();

    return {};
  }

  public async logout(): Promise<void> {
    (await this.tap.service.interface.logout()).successful();
  }

  /**
   * Change password for the groupId
   * @param newPassword the new password for the userId
   * @param userId the user id for which we want to change the password
   */
  public async changePassword(
    newPassword: string,
    userId: number,
  ): Promise<void> {
    if (this.hashPassword) {
      const passwordBytes = hashLoginPassword(newPassword);
      (
        await this.tap.service.group.changePasswordKey(userId, passwordBytes)
      ).successful();
    } else {
      (
        await this.tap.service.group.changePassword(userId, newPassword)
      ).successful();
    }
  }
}
